// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1b0gU","col":"styles_col__30_Et","fulfillmentStatus":"styles_fulfillmentStatus__1hPiE","emailCol":"styles_emailCol__2zs7q"};